import type { StoryBlock } from '../types/advertorial'

export const publication = {
  brand: 'Healthy Living Daily',
  tag: 'Sponsored Advertorial',
  kicker: 'Weight Loss · Real Stories'
}

export const article = {
  headline:
    'From 210Lbs to 149 & Back To My Skinny Jeans At 56 With A Delicious Costa Rican Tea',
  author: 'Linda Campbell',
  updated: 'Updated Today',
  readingTime: '6 min read',
  intro:
    '"Hi, I\'m Linda and I\'m 56 years old. I am sharing my story here because I am really proud of the fact that I was able to lose 61lbs quite easily by drinking a Costa Rican delicious slimming-tea daily!"',
  signature: 'Linda Campbell',
  signatureTitle: 'Costa Rica Tea Community Member'
}

export const offerUrl =
  'https://hop.clickbank.net/?affiliate=chapin89&vendor=allslimtea&op=vsl26&tid=tracking'

export const ctaLabel = 'Click Here For The Tea Recipe!'
export const inlineLinkText =
  'Go Here To Get The Costa Rican Tea Recipe & Get Great Results Fast!'

export const storyBlocks: StoryBlock[] = [
  {
    kind: 'paragraph',
    text: "Now, ever since starting a family 20 years ago I've struggled with my weight..."
  },
  {
    kind: 'paragraph',
    text: 'I knew having a child would leave me with a few extra pounds...'
  },
  {
    kind: 'paragraph',
    text: "But I didn't realize how hard it would be to stay in shape as a mother... I mean even for a tall woman like me..."
  },
  {
    kind: 'paragraph',
    text: 'It only dawned on me recently how bad things were when I was told by my Doctor that my blood sugar is too high and that I might develop diabetes...'
  },
  {
    kind: 'paragraph',
    text: "Given the less-than-active lifestyle I had, it shouldn't have been a big surprise."
  },
  {
    kind: 'paragraph',
    text: 'But the news made me really scared of course.'
  },
  {
    kind: 'paragraph',
    text: 'And when I thought about all the health problems it could lead to, I became terrified.'
  },
  {
    kind: 'paragraph',
    text: 'I started making small changes; reducing my portion size, trying to cut out the snacks, and even tried a few workouts.'
  },
  {
    kind: 'paragraph',
    text: 'But when the current global situation came along, I got so stressed and worried I began to comfort eat.'
  },
  {
    kind: 'paragraph',
    text: 'I know this was the worst thing I could have done, but in my head, I kept justifying it.'
  },
  {
    kind: 'paragraph',
    text: 'Certain things were beyond my control after all. Plus, what else could I do?'
  },
  {
    kind: 'paragraph',
    text: 'Gyms were closed, and I never enjoyed working out in the park as everyone was always staring at me...'
  },
  { kind: 'divider', text: 'then everything changed' },
  {
    kind: 'paragraph',
    text: "A friend of mine told me about how she was getting great results by drinking a few cups of a Costa Rican tea every day, but I didn't believe her!"
  },
  {
    kind: 'paragraph',
    text: 'But then I came across a story on my news feed about a woman who was a little older than me and had lost over 100 pounds with the same Costa Rican tea.'
  },
  {
    kind: 'paragraph',
    text: 'So, I decided to get the recipe and start drinking a few cups of tea every day!'
  },
  { kind: 'link', text: inlineLinkText },
  {
    kind: 'paragraph',
    text: 'But just to be sure, I managed to get a video call with my Doctor...'
  },
  {
    kind: 'paragraph',
    text: 'I shared the tea specifications and ingredients with him and he told me it looked perfect for me to try.'
  },
  { kind: 'paragraph', text: "And that's exactly what I did!" },
  {
    kind: 'paragraph',
    text: 'The first thing I noticed was the fact that I became full of energy and I was able to control my urges to comfort eat.'
  },
  {
    kind: 'paragraph',
    text: 'In fact, after drinking the tea in the morning, I was not hungry anymore.'
  },
  {
    kind: 'paragraph',
    text: 'In the first few weeks I was able to lose almost 2 inches off my waistline without a strict diet or exercises.'
  },
  {
    kind: 'paragraph',
    text: 'Having regained control over my eating and having seen that something is finally working, gave me a big confidence boost too, which helped me get a promotion at my job.'
  },
  {
    kind: 'paragraph',
    text: 'I continued drinking a few cups of tea every day and I decided to start eating healthier.'
  },
  {
    kind: 'paragraph',
    text: 'Instead of pizza I went for grilled chicken with some vegetables, and so on...'
  },
  {
    kind: 'paragraph',
    text: 'I am feeling amazing, plus I was slowly getting toned as well.'
  },
  {
    kind: 'paragraph',
    text: 'I lost a total of 61lbs and my body completely changed as I started to develop an attractive shape.'
  },
  {
    kind: 'paragraph',
    text: 'I really think everyone should try the Costa Rican tea because it was a huge help for me!'
  },
  { kind: 'link', text: inlineLinkText },
  { kind: 'paragraph', text: 'In fact, I am sure you\'ll love it!"' }
]

export const sidebar = {
  badge: 'Featured Offer',
  photo: {
    src: 'https://cdn.magicpatterns.com/uploads/jfBsR8Ayj4njW3aUsEHdyF/linda.jpg',
    alt: 'Linda smiling, wearing a camel turtleneck, pink coat and light blue trousers',
    caption: 'Linda, today at 149lbs'
  },
  progress: {
    title: "Linda's Progress",
    before: { value: '210', label: 'Before (lbs)' },
    now: { value: '149', label: 'Now (lbs)' },
    badge: '−61 lbs Lost'
  },
  cta: {
    heading: 'Ready to start your own journey?',
    sub: 'Free recipe · No purchase required to view'
  },
  summary: {
    title: 'What She Drank',
    items: [
      '1 warm cup each morning before breakfast',
      'Costa Rican loose-leaf slimming tea',
      'No other diet changes needed'
    ]
  }
}

export const legal = {
  paragraphs: [
    "*It's important to know that results are not typical and that results may vary greatly and specific results are not guaranteed because every woman is unique, of course.",
    'This is an advertorial and not an actual news article, blog, or consumer protection update. Our aim is to bring consumers the best information that may help them make informed decisions. This page is for demonstration purposes only. By proceeding forward you automatically agree to our terms and conditions.',
    'The information on this website has not been evaluated by the Food & Drug Administration or any other medical body. We do not aim to diagnose, treat, cure or prevent any illness or disease. Information is shared for educational purposes only. You should always consult your doctor before acting on any content on this website, especially if you are pregnant, nursing, taking medication or have a medical condition.',
    'Results shared on this page do not reflect the typical purchaser\'s experience, and are not intended to represent or guarantee that anyone will achieve the same or similar results. We are not giving any medical advice and all information on this website is for informational purposes only. By using our tips or products or programs, every person is doing so at their own risk and knowingly waive all rights to make any legal claims against the site owners.'
  ],
  links: [
    'Terms Of Service',
    'Contact',
    'Home',
    'Order Now',
    'Privacy Policy',
    'Full Disclaimer'
  ],
  copyright: '© 2024 Healthy Living Daily. All rights reserved.'
}
